module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-117.4fbc560b.svg";